<template>
  <div>
    <svg :width="2*blockWidth" :height="13*blockHeight" ref="svg">
      <g v-for="(element, index) in data" :key="'a'+element">
        <g>
          <circle 
            :cx="getX(index)+11" 
            :cy="getY(index)+11" 
            r="11" 
            stroke-width="0" 
            fill="black" 
          />
          <text
            :x="getX(index)+11" 
            :y="getY(index)+16"
            text-anchor="middle"
            font-size="18"
            fill="white"
            font-family="Myriad for FAZ, Helvetica, sans-serif"
            font-weight="bold"
          >
            {{index+1}}
          </text>
          <text
            :x="getX(index)+32" 
            :y="getY(index)+18"
            text-anchor="start"
            font-size="20"
            fill="black"
            font-family="Myriad for FAZ, Helvetica, sans-serif"
            font-weight="bold"
          >
            {{element.title.split(',')[0]}}
          </text>
          <text v-if="element.auszaehlungsstand"
            :x="getX(index)+32" 
            :y="getY(index)+chartHeight+60"
            text-anchor="start"
            font-size="18"
            fill="#666"
            font-family="Myriad for FAZ, Helvetica, sans-serif"
          >
            Auszählungsstand: {{String(element.auszaehlungsstand).replace('.',',')}}%
          </text>
        </g>
        <ColumnChart
          :data="element"
          :colors="parties"
          :x="getX(index)+32"
          :y="getY(index)+32"
          :height="chartHeight"
          :width="chartWidth"
          :fontSize="20"
          :barMargin="20"
          :elipsis="false"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import ColumnChart from '@/components/ColumnChart.vue'

export default {
  name: 'barsLayout',
  components: {
    ColumnChart,
  },
  props: {
    data: Object,
    parties: Array,
    height: Number,
    yRange: Array,
    suffix: String
  },
  data () {
    return {
      width: 600,
      barMargin: 5,
      layout: [...Array(26).keys()],
      blockHeight: 288,
      chartHeight: 180,
      chartWidth: 430,
      blockWidth: 560,
      blockMargin: { right: 96, bottom: 60}
    }
  },
  methods: {
    getX (index) {
      return index%2*(this.blockWidth)
    },
    getY (index) {
      return Math.floor(index/2)*this.blockHeight
    }
  },
  computed: {
    // yRangeComputed: function () {
    //   if (this.yRange) {
    //     return this.yRange
    //   } else {
    //     let min = Math.min(...this.data.rows[0])
    //     if (min > 0) { min = 0 }
    //     let max = Math.max(...this.data.rows[0])
    //     return [min, max]
    //   }
    // },
    // barThickness: function () {
    //   let n = this.data.cols.length
    //   // return n
    //   return (this.width - this.barMargin*(n-1))/n
    // }
  },
  mounted () {
    // this.fitProjection()
    // window.addEventListener('resize', debounce(this.fitProjection, 250))
    // setTimeout(() => { this.fitProjection() }, 2000)
  },
  updated () {
    // this.fitProjection()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>